import { PASS_STATUS } from '../BusinessPage/activity';

// SAM-1321 (U21): what the toast says after a pass moves to a status. The user sees «pass», never «invitation» or «access».
const PASS_STATUS_TOAST: Record<number, string> = {
  [PASS_STATUS.approved]: 'Pass confirmed',
  [PASS_STATUS.in]: 'Pass checked in',
  [PASS_STATUS.out]: 'Pass checked out',
  [PASS_STATUS.cancelled]: 'Pass cancelled',
};

export const passStatusToast = (statusId?: number | null): string =>
  (statusId != null && PASS_STATUS_TOAST[statusId]) || 'Pass updated';

export const PASS_UPDATE_ERROR = 'Error updating pass';
